import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type BrandColorsState = {
  map: Record<string, string>
}

const initialState: BrandColorsState = {
  map: {},
}

const brandColorsSlice = createSlice({
  name: 'brandColors',
  initialState,
  reducers: {
    // Merge new keys into the map
    setBrandColorsMap(state, action: PayloadAction<Record<string, string>>) {
      state.map = { ...state.map, ...action.payload }
    },
    // Replace entire slice state (used for loading from persisted storage)
    setBrandColorsState(_state, action: PayloadAction<BrandColorsState | undefined>) {
      return action.payload ?? initialState
    },
    resetBrandColors() {
      return initialState
    },
  },
})

export const { setBrandColorsMap, setBrandColorsState, resetBrandColors } = brandColorsSlice.actions
export default brandColorsSlice.reducer
